export default function($store, $formValues, approval, documentId, documentRevId, showForm) {
  $store.commit('nette/updateControl', {
    controlName: 'approvalForm',
    data: true,
    key: 'showModal'
  })
  $store.commit('nette/updateControl', {
    controlName: 'approvalForm',
    data: approval,
    key: 'approval'
  })
  $store.commit('nette/updateControl', {
    controlName: 'approvalForm',
    data: showForm,
    key: 'showForm'
  })

  $formValues['frm-approvalForm-approvalForm-bc_document_id'] = documentId
  $formValues['frm-approvalForm-approvalForm-bc_document_rev_id'] = documentRevId

  if (!showForm) {
    return
  }

  if (approval) {
    const approversItems = approval.approvers
      ? approval.approvers
        .filter((approver) => !approver.is_team_member)
        .map((approver) => {
          return {
            id: approver.user.id,
            label: approver.user.name != '' && approver.user.name != '?'
              ? approver.user.name + ' ' + approver.user.surname
              : approver.user.email,
            inicials: approver.user.inicials
          }
        })
      : []
    
    const approversValue = approval.approvers
      ? approval.approvers
        .filter((approver) => !approver.is_team_member)
        .map((approver) => approver.user.id)
      : []
    
    if (approval.approval_teams) {
      approval.approval_teams.forEach((team) => {
        if (!team.id) {
          return
        }

        approversItems.push({
          id: 'team-' + team.id,
          label: team.name,
          inicials: team.name.substring(0, 1)
        })

        approversValue.push('team-' + team.id)
      })
    }

    $formValues['frm-approvalForm-approvalForm-message'] = approval.message
    $store.commit('nette/updateControl', {
      controlName: 'frm-approvalForm-approvalForm-approvers',
      data: approversItems,
      key: 'items'
    })
    $formValues['frm-approvalForm-approvalForm-approvers'] = approversValue

  } else {
    $formValues['frm-approvalForm-approvalForm-message'] = ''
    $store.commit('nette/updateControl', {
      controlName: 'frm-approvalForm-approvalForm-approvers',
      data: [],
      key: 'items'
    })
    $formValues['frm-approvalForm-approvalForm-approvers'] = []
  }
}